// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__czqyd","active":"Tabs_active__1tAuh"};